module.exports = {
          srcSet: __webpack_public_path__ + "b58d573685ea46f163765e603dee196d-38.png"+" 38w",
          images:[ {path: __webpack_public_path__ + "b58d573685ea46f163765e603dee196d-38.png",width: 38,height: 34}],
          src: __webpack_public_path__ + "b58d573685ea46f163765e603dee196d-38.png",
          toString:function(){return __webpack_public_path__ + "b58d573685ea46f163765e603dee196d-38.png"},
          
          width: 38,
          height: 34
        }